import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import * as styles from './ButtonGroup.module.scss';
export function useButtonGroupStyles(props) {
    const { className } = props;
    return clsx(styles.buttonGroup, className);
}
export const ButtonGroup = ({ children, className, ...props }) => {
    const buttonGroupStyles = useButtonGroupStyles({ className });
    return (_jsx("div", { role: "group", className: buttonGroupStyles, ...props, children: children }));
};
export default ButtonGroup;
